import { jwtDecode } from 'jwt-decode'
import { defineStore } from 'pinia'

import { relaunchApi } from '@/logic/relaunchApi'
import store from '@/store'

export const useWebPubSubStore = defineStore('webPubSubStore', {
  state: () => ({
    webPubSubToken: null,
    webPubSubTokenAppId: null,
  }),
  actions: {
    async updateWebPubSubToken() {
      this.webPubSubTokenAppId = store.getters['auth/appId']
      try {
        const response = await relaunchApi.post('/global/web-pub-sub/create-token')
        this.webPubSubToken = response.token
        return this.webPubSubToken
      } catch (error) {
        this.webPubSubToken = null
        console.error('Failed to fetch Web PubSub token:', error)
        throw error
      }
    },
    async getWebPubSubToken() {
      if (!this.webPubSubToken) {
        const token = await this.updateWebPubSubToken()
        return token
      }
      const decodedToken = jwtDecode(this.webPubSubToken)

      if (!decodedToken.exp) {
        throw new Error('The expiration of the JWT is invalid!')
      }
      const nextRefreshTime = (decodedToken.exp - 60) * 1000 // Refresh token 60 seconds before it expires
      if (nextRefreshTime < new Date().getTime()) {
        const token = await this.updateWebPubSubToken()
        return token
      }
      return this.webPubSubToken
    },
  },
})
